import React from "react";
import { Link } from "react-router-dom";
import { createPopper } from "@popperjs/core";
import PersonIcon from "@material-ui/icons/Person";
import InfoIcon from "@material-ui/icons/Info";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import HelpIcon from "@material-ui/icons/Help";

const UserDropdown = () => {
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  const logout = () => {
    setDropdownPopoverShow(false);
    localStorage.clear();
    window.location.reload();
  };

  const [avatar, setAvatar] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/usrimage/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setAvatar(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <a
        className="text-blueGray-500 block"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <div className="items-center flex">
          <span className="w-8 h-8 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full mr-2">
            <img
              alt="..."
              className="w-full rounded-full align-middle border-none shadow-lg"
              src={
                avatar
                  ? avatar.cover
                  : require("assets/img/theme/userimg.png").default
              }
            />
          </span>
          <span className="text-white text-sm hidden lg:inline-block font-semibold">
            {localStorage.getItem("user")}
          </span>
        </div>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded1 shadow-lg min-w-48 dropdown-menu-arrow square"
        }
        right
      >
        <h6 className="heading-small m-0">Welcome!</h6>
        <Link
          to="/admin/userprofile"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => {
            setDropdownPopoverShow(false);
          }}
        >
          <PersonIcon /> &nbsp; My profile
        </Link>
        <Link
          to="/admin/about"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => {
            setDropdownPopoverShow(false);
          }}
        >
          <InfoIcon /> &nbsp; About
        </Link>
        <Link
          to="/support"
          target="_blank"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => {
            setDropdownPopoverShow(false);
          }}
        >
          <HelpIcon /> &nbsp; Support
        </Link>
        <div className="h-0 my-2 border border-solid border-blueGray-100" />
        <Link
          to="/auth/login"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => {
            e.preventDefault();
            logout();
          }}
        >
          <DirectionsRunIcon /> &nbsp; Logout
        </Link>
      </div>
    </>
  );
};

export default UserDropdown;